import React from 'react';
import {useTheme} from '../../../theme';
import {tID} from '../../../utils/TestIdHelper';
import BottomExpandableDrawer from '../BottomExpandableDrawer';
import {SmileIcon} from '../../../utils/SvgIcons';

const FaceIdIdentfyingDrawer = ({visible, onClose}) => {
  const {colors} = useTheme();
  return (
    <BottomExpandableDrawer
      testID={tID('FaceIdIdentfyingDrawer-Modal-BottomExpandableDrawer')}
      visible={visible}
      showRipple
      rippleColor={colors.accent}
      rippleIcon={<SmileIcon />}
      iconSize={72}
      title="Identifying Face ID..."
      subtitle="Look into the camera and hold still."
      onClose={onClose}
    />
  );
};

export default FaceIdIdentfyingDrawer;
